import {BillRestResource} from "@/api/billing/billing-rest-resource";
import {BILLING_SERVER} from "@/api";
const DataRecordApi = new BillRestResource({server: BILLING_SERVER, resource: 'data-record'});


export default DataRecordApi;
